import React from 'react';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { Button } from '../components/ui/button';

/** Página para cualquier dirección que no existe. */
const NoEncontradaPage = () => (
  <div className="min-h-[60vh] flex items-center justify-center px-4 py-20">
    <div className="text-center max-w-md">
      <div className="w-14 h-14 rounded-full bg-slate-100 flex items-center justify-center mx-auto mb-5">
        <Compass className="w-7 h-7 text-slate-500" />
      </div>

      <h1 className="font-heading text-3xl font-semibold text-slate-900 mb-3">
        Esta página no existe
      </h1>
      <p className="text-slate-600 mb-8">
        Puede que el enlace esté mal escrito o que la página se haya movido.
      </p>

      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link to="/">
          <Button className="bg-teal-600 hover:bg-teal-700 text-white rounded-full px-8 w-full">
            Ir al inicio
          </Button>
        </Link>
        <Link to="/agendar">
          <Button variant="outline" className="rounded-full px-8 w-full">
            Agendar una sesión
          </Button>
        </Link>
      </div>
    </div>
  </div>
);

export default NoEncontradaPage;
